import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'lk-article-card',
  templateUrl: './article-card.component.html',
  styleUrls: ['./article-card.component.scss'],
  host: {
    '[class]' : 'col-6'
  }
})
export class ArticleCardComponent {
  @Input() article;
  @Input() publication;

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/components/article-card/article-card.component.ts